import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import DropdownContentWrapper from '@Components/Popup/Dropdown/DropdownContentWrapper';

import './HeatmapNavigatorButton.scss';

function HeatmapNavigatorButton({
  toggleNavigator = () => {
    Logger.error('something went wrong with toggleNavigator prop from angular');
  },
  navigatorDisabled,
}) {
  return (
    <div className="result-toolbar-heatmap-navigator-button">
      <ButtonWithIcon
        data-e2e="heatmap-navigator-button"
        type="borderless"
        size="small"
        linkIconSize="s"
        sprite="Compass"
        layout="vertical"
        tabIndex="0"
        disabled={navigatorDisabled}
        onClick={() => {
          toggleNavigator();
        }}
        className="result-toolbar-heatmap-navigator-button-control e2e-navigator"
        aria-label="Toggle heatmap navigator">
        Navigator
      </ButtonWithIcon>
      {navigatorDisabled && (
        <DropdownContentWrapper className="result-toolbar-heatmap-navigator-button-no-image" horizontalAlignment="left">
          Navigator image is not available.
        </DropdownContentWrapper>
      )}
    </div>
  );
}

HeatmapNavigatorButton.propTypes = {
  toggleNavigator: PropTypes.func,
  navigatorDisabled: PropTypes.bool,
};

export default HeatmapNavigatorButton;
